<template>
  <div class="upload-file-box">
    <a-upload
      name="upload"
      list-type="picture-card"
      :file-list="fileList"
      :headers="headers"
      :data="data"
      :action="uploadUrl"
      :remove="remove"
      :before-upload="beforeUpload"
      @preview="handlePreview"
      @change="handleChange"
      :multiple="true"
    >

      <div v-if="fileList.length < maxNum">
        <a-icon :type="loading ? 'loading' : 'upload'" />
        <div class="ant-upload-text">点击上传</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <video v-if="types[previewImage] == 3" controls style="width: 100%" :src="previewImage" />
      <img v-else alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<style lang="less" scoped>
@import 'UploadFile';
</style>

<script>
import UploadFile from './UploadFile'
export default UploadFile
</script>
